import i18n from 'i18next';
import { initReactI18next } from 'react-i18next';

import ruTranslation from './locales/ru.json';
import enTranslation from './locales/en.json';
import plTranslation from './locales/pl.json';
import deTranslation from './locales/de.json';
import ukTranslation from './locales/uk.json';

const resources = {
  ru: {
    translation: ruTranslation,
  },
  en: {
    translation: enTranslation,
  },
  pl: {
    translation: plTranslation,
  },
  de: {
    translation: deTranslation,
  },
  uk: {
    translation: ukTranslation,
  },
};

// Функція для отримання мови з API або localStorage
const getInitialLanguage = (): string => {
  // Спочатку перевіряємо localStorage для швидкої ініціалізації
  const savedLanguage = localStorage.getItem('language');
  if (savedLanguage) {
    console.log('i18n init: Using language from localStorage:', savedLanguage);
    return savedLanguage;
  }
  
  // Якщо немає в localStorage, перевіряємо збереженого користувача
  // Використовуємо той самий підхід що і storage.get
  try {
    const savedUserStr = localStorage.getItem('user');
    if (savedUserStr) {
      const savedUser = JSON.parse(savedUserStr);
      if (savedUser?.language) {
        console.log('i18n init: Using language from saved user:', savedUser.language);
        // Зберігаємо мову в localStorage для наступних завантажень
        localStorage.setItem('language', savedUser.language);
        return savedUser.language;
      }
    }
  } catch (error) {
    console.error('Error parsing saved user:', error);
  }
  
  console.log('i18n init: Using default language: en');
  return 'en';
};

i18n.use(initReactI18next).init({
  resources,
  lng: getInitialLanguage(),
  fallbackLng: 'ru',
  debug: import.meta.env.DEV,

  interpolation: {
    escapeValue: false,
  },

  load: 'languageOnly',
  cleanCode: true,

  defaultNS: 'translation',
  ns: ['translation'],

  keySeparator: '.',
  nsSeparator: ':',
});

// Слухаємо зміни в localStorage для синхронізації мови
if (typeof window !== 'undefined') {
  window.addEventListener('storage', (e) => {
    if (e.key === 'language' && e.newValue) {
      i18n.changeLanguage(e.newValue);
    }
  });
}

export default i18n;
